import { useNavigate } from "react-router-dom";
import { v4 } from "uuid";

export interface IVideo_Treinamento_YouTube {
  id: string;
  title: string;
  description: string;
  duration: string;
  videoId: string;
}

export const VIDEOS_TREINAMENTO_YOUTUBE: IVideo_Treinamento_YouTube[] = [
  {
    id: v4(),
    title: "Processo de Vistoria Veicular",
    description:
      "Procedimentos, orientações e boas práticas para a realização de vistorias veiculares.",
    duration: "20 min",
    videoId: "f0vwi3h0MA0?si=F5kaoIb2grP1kFQK",
  },
  {
    id: v4(),
    title: "Antissuborno ECVs",
    description: "Treinamento de antissuborno alinhado à Lei 12.846/2013.",
    duration: "23 min",
    videoId: "tQei7cYmFks?si=xS9i_TbNgyOTxEOI",
  },
  {
    id: v4(),
    title: "Erros de Vistorias",
    description:
      "Principais erros identificados no processo de vistoria veícular por nível de criticidade.",
    duration: "05 min",
    videoId: "f_rURRXSKeo?si=ncTvULIzDuzmKZGG",
  },
];

export const useTrainings = () => {
  const navigate = useNavigate();
  return { navigate, VIDEOS_TREINAMENTO_YOUTUBE };
};
